ScoreTrekBattle.League = ScoreTrekBattle.League || {};

ScoreTrekBattle.League.Matchdays = (function() {
    var _this, CONFIG, STATUS, CACHE;

    CONFIG = {
        STORAGE_KEY: 'ScoreTrekBattle.League.Matchdays.Cache',
        CACHE_SIZE: 10,
        // Country and region carry no season, so the country is picked first.
        // Everything structural below the season is keyed by it.
        FILTER_ORDER: ['countryId', 'seasonId', 'federationId', 'divisionId', 'leagueId', 'groupId', 'clubId', 'squadId'],
        WIZARD_STEPS: ['countryId', 'seasonId', 'federationId'],
        LIST_REQUIRED_FILTERS: ['countryId', 'seasonId'],
        VIEW_ID: '/league/matchdays',
        // Segment order of the shareable URL. Country, season, federation and
        // division travel as their own id — those are short and stable anyway.
        // League, group, club and squad would be far too long as ids and use
        // their short slug instead.
        PATH_ORDER: [
            {key: 'countryId', useSlug: false, isSkippable: false, requires: []},
            {key: 'seasonId', useSlug: false, isSkippable: false, requires: []},
            {key: 'federationId', useSlug: false, isSkippable: true, requires: []},
            {key: 'divisionId', useSlug: false, isSkippable: true, requires: []},
            {key: 'leagueId', useSlug: true, isSkippable: true, requires: ['divisionId']},
            {key: 'groupId', useSlug: true, isSkippable: true, requires: ['leagueId']},
            {key: 'clubId', useSlug: true, isSkippable: false, requires: []},
            {key: 'squadId', useSlug: true, isSkippable: false, requires: ['divisionId', 'clubId']}
        ],
        PATH_PLACEHOLDER: '-',
        SHARE_NAME_FILTERS: ['squadId', 'clubId', 'leagueId', 'divisionId', 'federationId', 'countryId']
    };

    CACHE = {};

    function resetStatus() {
        STATUS = {
            active: false,
            isLoading: false,
            isFiltersLoaded: false,
            isRendering: false,
            isRestoring: false,
            listRequestId: 0,
            view: null,
            $view: null,
            $list: null,
            $loadMore: null,
            observer: null,
            controls: {},
            optionalFilters: {},
            wizardFilters: {},
            pathArgs: [],
            // Zuordnung Filterwert -> URL-Slug, je Filter gesammelt sobald
            // dessen Optionen geladen sind (siehe collectOptionSlugs).
            optionSlugs: {},
            CURRENT: {}
        };
    }
    resetStatus();

    // ── Cache ────────────────────────────────────────────────

    function createCacheItem(filters) {
        return {
            filters: DataHandler.cloneObject(filters || {}),
            path: '',
            scrollTop: 0,
            offset: 0,
            now: 0,
            items: [],
            hasMore: false,
            timestamp: 0
        };
    }

    function resetCacheItem(cacheItem) {
        cacheItem.scrollTop = 0;
        cacheItem.offset = 0;
        cacheItem.now = 0;
        cacheItem.items = [];
        cacheItem.hasMore = false;
        cacheItem.timestamp = 0;
    }

    function getCacheItem(path) {
        return (path && CACHE.items.hasOwnProperty(path)) ? CACHE.items[path] : null;
    }

    function registerCacheItem(cacheItem, path) {
        if (cacheItem.path && (cacheItem.path !== path) && (CACHE.items[cacheItem.path] === cacheItem)) {
            delete CACHE.items[cacheItem.path];
        }

        cacheItem.path = path;
        CACHE.items[path] = cacheItem;
        CACHE.order = CACHE.order.filter(function(cachedPath) {
            return (cachedPath !== path) && CACHE.items.hasOwnProperty(cachedPath);
        });
        CACHE.order.push(path);
        CACHE.lastPath = path;
        CACHE.lastFilters = DataHandler.cloneObject(cacheItem.filters);

        while (CACHE.order.length > CONFIG.CACHE_SIZE) {
            delete CACHE.items[CACHE.order.shift()];
        }
    }

    function detachCacheItem() {
        if (STATUS.CURRENT.path) {
            STATUS.CURRENT = createCacheItem(STATUS.CURRENT.filters);
        }
    }

    function loadCache() {
        var storeData;

        CACHE = {
            items: {},
            order: [],
            lastPath: '',
            lastFilters: {}
        };

        try {
            storeData = JSON.parse(localStorage.getItem(CONFIG.STORAGE_KEY));
        } catch (error) {
            storeData = null;
        }

        if (!storeData || (typeof storeData !== 'object')) {
            return;
        }

        if (storeData.matchdays && storeData.matchdays.filters) {
            storeData.lastFilters = storeData.matchdays.filters;
        }

        CACHE.lastPath = String(storeData.lastPath || '');
        CACHE.lastFilters = (storeData.lastFilters && (typeof storeData.lastFilters === 'object')) ? storeData.lastFilters : {};
    }
    loadCache();

    function storeCache() {
        localStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify({
            lastPath: CACHE.lastPath,
            lastFilters: CACHE.lastFilters
        }));
    }

    function storeScrollTop(scrollTop) {
        var offset;

        if (!STATUS.$view) {
            return;
        }

        offset = 0;

        if (STATUS.$view.find('[data-id="filters"]').hasClass('isOpen')) {
            offset = STATUS.$view.find('[data-id="filtersContent"]').outerHeight() || 0;
        }

        STATUS.CURRENT.scrollTop = scrollTop - offset;
        storeCache();
    }

    // ── Filter cascade ──────────────────────────────────────

    function getFilterControls() {
        var controls, optionalFilters;

        controls = {};
        optionalFilters = {};

        Object.values(STATUS.view.controls).forEach(function(control) {
            var filterKey;

            filterKey = control.$view[0].dataset.filter;

            if (filterKey) {
                controls[filterKey] = control;

                if (control.$view[0].dataset.filterOptional === 'true') {
                    optionalFilters[filterKey] = true;
                }
            }
        });

        STATUS.optionalFilters = optionalFilters;

        return controls;
    }

    function isOptionalFilter(filterKey) {
        return !!STATUS.optionalFilters[filterKey];
    }

    function getNextFilterKey(filterKey) {
        var index;

        index = CONFIG.FILTER_ORDER.indexOf(filterKey);

        if (index === -1 || index >= CONFIG.FILTER_ORDER.length - 1) {
            return null;
        }

        return CONFIG.FILTER_ORDER[index + 1];
    }

    function initFilters() {
        var $filtersContent;

        if (!STATUS.$view) {
            return;
        }

        $filtersContent = STATUS.$view.find('[data-id="filtersContent"]');
        $filtersContent.addClass('loading');

        STATUS.controls = getFilterControls();

        CONFIG.FILTER_ORDER.forEach(function(filterKey, index) {
            var control;

            control = STATUS.controls[filterKey];

            if (!control) {
                return;
            }

            if (index > 0) {
                disableFilter(filterKey);
            }

            control.on('change', function() {
                onFilterChange(filterKey);
            });
        });

        STATUS.isFiltersLoaded = true;
        $filtersContent.removeClass('loading');

        if (restoreCachedList()) {
            STATUS.pathArgs = [];

            return;
        }

        // A path in the address bar wins over the cache: it is what the user
        // (or whoever shared the link) explicitly asked for.
        if (STATUS.pathArgs.length > 0) {
            restoreFiltersFromPath(STATUS.pathArgs.slice());
            STATUS.pathArgs = [];

            return;
        }

        // Load initial cascade and restore cached filters
        restoreFiltersFromCache();
    }

    function restoreCachedList() {
        STATUS.isRestoring = (STATUS.CURRENT.items.length > 0) && canLoadList();

        if (!STATUS.isRestoring) {
            return false;
        }

        updateList();
        restoreFiltersFromCache();

        return true;
    }

    function restoreFiltersFromCache() {
        var cachedFilters;

        cachedFilters = DataHandler.cloneObject(STATUS.CURRENT.filters || {});

        loadFilters('', cachedFilters);
    }

    // A shared link carries the selection in its path. The segments are short
    // slugs, so the server resolves them back into filter ids — it stops at the
    // first segment that no longer exists and returns everything up to there,
    // which opens the deepest level of a stale link that is still valid.
    function restoreFiltersFromPath(pathArgs) {
        Api.request('/battle/league/matchday/path', {path: pathArgs}).then(function(result) {
            var filters;

            filters = (result && result.filters) ? result.filters : {};

            detachCacheItem();
            STATUS.CURRENT.filters = filters;

            loadFilters('', DataHandler.cloneObject(filters));
        }).catch(function() {
            restoreFiltersFromCache();
        });
    }

    function onFilterChange(changedKey) {
        var changedValue;

        STATUS.isRestoring = false;
        detachCacheItem();

        changedValue = String(STATUS.controls[changedKey].get() || '').trim();

        if (changedValue) {
            STATUS.CURRENT.filters[changedKey] = changedValue;
        } else {
            delete STATUS.CURRENT.filters[changedKey];

            getDependentFilterKeys(changedKey).forEach(function(filterKey) {
                delete STATUS.CURRENT.filters[filterKey];

                if (STATUS.controls[filterKey]) {
                    STATUS.controls[filterKey].set('');
                }
            });
        }

        loadFilters(changedKey);
    }

    function getDependentFilterKeys(filterKey) {
        var dependents;

        dependents = [];

        CONFIG.PATH_ORDER.forEach(function(entry) {
            var isDependent;

            isDependent = entry.requires.some(function(requiredKey) {
                return (requiredKey === filterKey) || (dependents.indexOf(requiredKey) !== -1);
            });

            if (isDependent) {
                dependents.push(entry.key);
            }
        });

        return dependents;
    }

    // Collects "value -> short URL slug" out of one option list. The list is
    // either flat (value -> option) or grouped (label + options).
    //
    // The map is kept per filter and not read straight from the response,
    // because a change only refreshes the levels *below* it: picking a group
    // returns club and squad, never the group itself. Reading the slug from
    // that response would therefore always miss the level just chosen.
    function collectOptionSlugs(values) {
        var slugs;

        slugs = {};

        if (!values) {
            return slugs;
        }

        function collect(options) {
            Object.keys(options || {}).forEach(function(value) {
                var option;

                option = options[value];

                if (option && (typeof option === 'object') && option.slug) {
                    slugs[value] = option.slug;
                }
            });
        }

        if (Array.isArray(values)) {
            values.forEach(function(group) {
                collect(group && group.options);
            });

            return slugs;
        }

        collect(values);

        return slugs;
    }

    // Mirrors the chosen filters into the address bar so the view can be shared
    // as a link. The path is cut off at the first level that is not chosen — a
    // partial selection therefore yields a correspondingly short URL.
    function updatePath() {
        var path;

        path = buildPath();
        ScoreTrekBattle.View.setPath(path);

        return path;
    }

    function buildPath() {
        var filters, segments, placeholders;

        filters = STATUS.CURRENT.filters || {};
        segments = [];
        placeholders = [];

        CONFIG.PATH_ORDER.every(function(entry) {
            var value, known, isMissingRequired;

            value = filters[entry.key] || '';

            if (!value) {
                if (!entry.isSkippable) {
                    return false;
                }

                placeholders.push(CONFIG.PATH_PLACEHOLDER);

                return true;
            }

            isMissingRequired = entry.requires.some(function(requiredKey) {
                return !filters[requiredKey];
            });

            if (isMissingRequired) {
                return false;
            }

            if (entry.useSlug) {
                known = STATUS.optionSlugs[entry.key] || {};
                value = known[value] || '';
            }

            if (!value) {
                return false;
            }

            segments = segments.concat(placeholders, [encodeURIComponent(value)]);
            placeholders = [];

            return true;
        });

        return CONFIG.VIEW_ID + (segments.length ? `/${segments.join('/')}` : '');
    }

    function getShareName() {
        var filterKey;

        filterKey = CONFIG.SHARE_NAME_FILTERS.find(function(key) {
            return !!(STATUS.CURRENT.filters || {})[key] && !!STATUS.controls[key];
        });

        if (!filterKey) {
            return __i18n('share/name/matchdays');
        }

        return __i18n('share/name/matchdaysOf', {name: STATUS.controls[filterKey].getText()});
    }

    function loadFilters(changedKey, restoreValues) {
        var requestId;

        STATUS.filterRequestId = (STATUS.filterRequestId || 0) + 1;
        requestId = STATUS.filterRequestId;

        Api.request('/battle/league/matchday/filters', {
            filters: restoreValues || STATUS.CURRENT.filters,
            changed: changedKey,
            resolveParents: true
        }).then(function(result) {
            var allFilters, disabled, restore, previousFilters, changedFilters, isRestored;

            // Ignore stale responses
            if (requestId !== STATUS.filterRequestId) {
                return;
            }

            if (!result || !result.filters) {
                return;
            }

            previousFilters = DataHandler.cloneObject(STATUS.CURRENT.filters);

            allFilters = result.filters;
            disabled = result.disabled || [];
            restore = $.extend({}, restoreValues || {}, result.resolved || {});

            // Disable filters the server says should be disabled
            disabled.forEach(function(filterKey) {
                if (STATUS.controls[filterKey]) {
                    resetFilter(filterKey);
                    disableFilter(filterKey);
                    delete STATUS.CURRENT.filters[filterKey];
                    delete STATUS.optionSlugs[filterKey];
                }
            });

            // Update only filters the server sent
            CONFIG.FILTER_ORDER.forEach(function(filterKey) {
                var filterData, options, autoSelect, beforeOptions, currentValue;

                if (!STATUS.controls[filterKey] || !allFilters.hasOwnProperty(filterKey)) {
                    return;
                }

                filterData = allFilters[filterKey];

                // Merken, solange die Optionen vorliegen — eine spätere Antwort
                // zu diesem Filter enthält sie nicht mehr.
                STATUS.optionSlugs[filterKey] = collectOptionSlugs(filterData.values);

                options = ScoreTrekBattle.League.Select.formatOptions(filterData.values || {});

                STATUS.controls[filterKey].setOptions(options, {'': `-- ${__i18n('filter/all')} --`});

                enableFilter(filterKey);

                // Restore cached value explicitly (setOptions can't restore from empty selects)
                if (restore[filterKey]) {
                    STATUS.controls[filterKey].set(restore[filterKey]);
                }

                // Sync STATUS.CURRENT.filters with what's actually selected
                currentValue = String(STATUS.controls[filterKey].get() || '').trim();

                if (currentValue) {
                    STATUS.CURRENT.filters[filterKey] = currentValue;
                } else {
                    delete STATUS.CURRENT.filters[filterKey];
                }
            });

            // Preselect the club's federation (country + federation) on a fresh
            // filter with nothing chosen yet.
            if (result.preselect) {
                ['countryId', 'federationId'].forEach(function(filterKey) {
                    if (STATUS.controls[filterKey] && result.preselect[filterKey]) {
                        STATUS.controls[filterKey].set(result.preselect[filterKey]);
                        STATUS.CURRENT.filters[filterKey] = result.preselect[filterKey];
                    }
                });
            }

            isRestored = STATUS.isRestoring && ListState.isEqual(previousFilters, STATUS.CURRENT.filters);
            STATUS.isRestoring = false;

            if (!isRestored && STATUS.CURRENT.path) {
                changedFilters = STATUS.CURRENT.filters;
                STATUS.CURRENT.filters = previousFilters;
                STATUS.CURRENT = createCacheItem(changedFilters);
            }

            indicateFilters();
            registerCacheItem(STATUS.CURRENT, updatePath());

            if (isRestored) {
                storeCache();
                return;
            }

            resetCacheItem(STATUS.CURRENT);
            storeCache();
            updateList();
        });
    }

    function enableFilter(filterKey) {
        var control;

        control = STATUS.controls[filterKey];

        if (!control) {
            return;
        }

        control.$view.removeClass('isDisabled');
        control.$view.find('select').prop('disabled', false);
    }

    function disableFilter(filterKey) {
        var control;

        control = STATUS.controls[filterKey];

        if (!control) {
            return;
        }

        control.$view.addClass('isDisabled');
        control.$view.find('select').prop('disabled', true);
    }

    function resetFilter(filterKey) {
        var control;

        control = STATUS.controls[filterKey];

        if (!control) {
            return;
        }

        control.setOptions({}, {'': `-- ${__i18n('filter/all')} --`});
        control.set(null);
    }

    function resetFilters() {
        detachCacheItem();
        STATUS.CURRENT.filters = {};
        CACHE.lastPath = '';
        CACHE.lastFilters = {};

        // Invalidate any pending loadFilters callbacks
        STATUS.filterRequestId = (STATUS.filterRequestId || 0) + 1;

        resetCacheItem(STATUS.CURRENT);

        CONFIG.FILTER_ORDER.forEach(function(filterKey, index) {
            resetFilter(filterKey);

            if (index > 0) {
                disableFilter(filterKey);
            }
        });

        storeCache();

        ScoreTrekBattle.View.setPath(CONFIG.VIEW_ID);
        indicateFilters();
        updateList();
    }

    function indicateFilters() {
        var filterCount;

        if (!STATUS.$view) {
            return;
        }

        filterCount = Object.keys(STATUS.CURRENT.filters || {}).length;

        STATUS.$view.attr('data-has-filters', filterCount ? 'yes' : 'no');
        STATUS.$view.find('[data-id="filterCount"]').text(filterCount);
    }

    function toggleFilters(isOpen) {
        if (!STATUS.$view) {
            return;
        }

        STATUS.filtersLockedUntil = Infinity;

        STATUS.$view.find('[data-id="filters"]').toggleClass('isOpen', isOpen);
        STATUS.$view.find('[data-id="filtersContent"]').stop()[isOpen ? 'slideDown' : 'slideUp'](200, function() {
            STATUS.filtersLockedUntil = Date.now() + 300;
        });
    }

    function isFiltersToggleLocked() {
        return Date.now() < (STATUS.filtersLockedUntil || 0);
    }

    function isFiltersObstructive() {
        let $filters, rect;

        $filters = STATUS.$view.find('[data-id="filters"]');

        if (!$filters.hasClass('isOpen')) {
            return false;
        }

        rect = $filters[0].getBoundingClientRect();

        return rect.height > ((window.innerHeight - ScoreTrekBattle.View.getViewportInsets().bottom - rect.top) / 3);
    }

    // ── List ─────────────────────────────────────────────────

    // ── Wizard ─────────────────────────────────────────────

    function hasAnyFilters() {
        return Object.keys(STATUS.CURRENT.filters).length > 0;
    }

    function showWizard() {
        var firstIncompleteStep;

        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-id="wizard"]').css('display', '');
        STATUS.$view.find('[data-id="listWrapper"]').css('display', 'none');
        STATUS.$view.find('[data-id="filters"]').css('display', 'none');

        updateHasMore(false);

        // Reset all wizard steps
        STATUS.$view.find('[data-wizard-step]').attr('data-visible', 'no').find('[data-id="wizardOptions"]').empty();
        STATUS.$view.find('.matchday-wizard-step-label').css('cursor', '').off('click');

        // Pre-populate wizard from existing filters
        STATUS.wizardFilters = {};
        firstIncompleteStep = 0;

        CONFIG.WIZARD_STEPS.forEach(function(key, idx) {
            if (STATUS.CURRENT.filters[key]) {
                STATUS.wizardFilters[key] = STATUS.CURRENT.filters[key];
                firstIncompleteStep = idx + 1;
            }
        });

        initWizardStep(0);
    }

    function hideWizard() {
        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-id="wizard"]').css('display', 'none');
        STATUS.$view.find('[data-id="listWrapper"]').css('display', '');
        STATUS.$view.find('[data-id="filters"]').css('display', '');
    }

    function initWizardStep(stepIndex) {
        var filterKey, $step, preselected;

        if (stepIndex >= CONFIG.WIZARD_STEPS.length) {
            finishWizard();
            return;
        }

        filterKey = CONFIG.WIZARD_STEPS[stepIndex];
        preselected = STATUS.wizardFilters.hasOwnProperty(filterKey) ? STATUS.wizardFilters[filterKey] : null;

        // Hide steps after current
        CONFIG.WIZARD_STEPS.forEach(function(key, idx) {
            if (idx > stepIndex) {
                STATUS.$view.find(`[data-wizard-step="${key}"]`).attr('data-visible', 'no');
            }
        });

        $step = STATUS.$view.find(`[data-wizard-step="${filterKey}"]`);
        $step.attr('data-visible', 'yes');

        loadWizardOptions(filterKey, $step, stepIndex, preselected);
    }

    function loadWizardOptions(filterKey, $step, stepIndex, preselected) {
        var $choices;

        $choices = $step.find('[data-id="wizardOptions"]').empty();

        Api.request('/battle/league/matchday/filters', {
            filters: STATUS.wizardFilters,
            changed: ''
        }).then(function(result) {
            var values;

            if (!result || !result.filters || !result.filters[filterKey]) {
                return;
            }

            values = result.filters[filterKey].values || {};

            renderWizardChoices($choices, values, preselected, filterKey, stepIndex);

            // If preselected value is valid, auto-advance
            if ((preselected !== null) && $choices.find('[data-selected="yes"]').length > 0) {
                attachStepBackHandler($step, filterKey, stepIndex);
                initWizardStep(stepIndex + 1);
            } else {
                AnimationHandler.scrollIntoView($step, true);
            }
        });
    }

    function renderWizardChoices($container, values, preselected, filterKey, stepIndex) {
        function getOptionText(option) {
            if (option && typeof option === 'object' && option.text) {
                return option.text;
            }

            return option;
        }

        function addChoice(key, option) {
            var $choice, $icon, text, shortName, icon, isLogo;

            text = getOptionText(option);
            shortName = (option && typeof option === 'object') ? (option.shortName || '') : '';
            // A country carries a flag, a federation a logo. A logo keeps its
            // aspect ratio instead of filling the circle.
            icon = (option && typeof option === 'object') ? (option.flag || option.logo || '') : '';
            isLogo = (option && typeof option === 'object') ? (!option.flag && !!option.logo) : false;

            $choice = $('<div class="matchday-wizard-step-choice">');

            // Logo and short name stand side by side — the short name is what
            // the user actually reads and recognises, so it stays even when a
            // logo is present.
            if (icon || shortName) {
                $icon = $('<div class="matchday-wizard-step-choice-icon">');

                if (option && option.faIcon) {
                    $icon.append($('<i>').addClass(option.faIcon));
                } else if (icon) {
                    $icon.append($('<div class="matchday-wizard-step-choice-icon-image">').toggleClass('is-logo', isLogo).css('background-image', `url('${icon}')`));
                }

                if (shortName) {
                    $icon.append($('<span class="matchday-wizard-step-choice-icon-shortname">').text(shortName));
                }

                $choice.append($icon);
            }

            $choice.append($('<div class="matchday-wizard-step-choice-label">').text(text));
            $choice.attr('data-value', key);
            $choice.attr('data-selected', (key === preselected) ? 'yes' : 'no');

            $choice.on('click', function() {
                selectWizardOption(filterKey, key, text, stepIndex);
            });

            $container.append($choice);
        }

        if (filterKey === 'federationId') {
            addChoice('', {
                text: __i18n('filter/allFederations'),
                shortName: __i18n('filter/all'),
                faIcon: 'fa-solid fa-building-columns'
            });
        }

        if (Array.isArray(values)) {
            values.forEach(function(group) {
                $container.append($('<div class="matchday-wizard-step-group-label">').text(group.label));

                Object.keys(group.options).forEach(function(key) {
                    addChoice(key, group.options[key]);
                });
            });
        } else {
            Object.keys(values).forEach(function(key) {
                addChoice(key, values[key]);
            });
        }
    }

    function attachStepBackHandler($step, filterKey, stepIndex) {
        $step.find('.matchday-wizard-step-label').css('cursor', 'pointer').off('click').on('click', function() {
            delete STATUS.wizardFilters[filterKey];

            CONFIG.WIZARD_STEPS.forEach(function(key, idx) {
                if (idx > stepIndex) {
                    delete STATUS.wizardFilters[key];
                }
            });

            $step.find('.matchday-wizard-step-label').css('cursor', '').off('click');

            initWizardStep(stepIndex);
        });
    }

    function selectWizardOption(filterKey, value, label, stepIndex) {
        var $step;

        STATUS.wizardFilters[filterKey] = value;

        $step = STATUS.$view.find(`[data-wizard-step="${filterKey}"]`);

        // Mark selected choice
        $step.find('.matchday-wizard-step-choice').attr('data-selected', 'no');
        $step.find(`[data-value="${value}"]`).attr('data-selected', 'yes');

        attachStepBackHandler($step, filterKey, stepIndex);

        initWizardStep(stepIndex + 1);
    }

    function finishWizard() {
        detachCacheItem();

        // Apply wizard selections to the real filters
        Object.keys(STATUS.wizardFilters).forEach(function(key) {
            if (STATUS.wizardFilters[key]) {
                STATUS.CURRENT.filters[key] = STATUS.wizardFilters[key];
            } else {
                delete STATUS.CURRENT.filters[key];
            }
        });

        STATUS.wizardFilters = {};

        hideWizard();

        // Load filters and list with the wizard selections
        loadFilters('', DataHandler.cloneObject(STATUS.CURRENT.filters));
    }

    // ── List ─────────────────────────────────────────────────

    function canLoadList() {
        return CONFIG.LIST_REQUIRED_FILTERS.every(function(filterKey) {
            return !!STATUS.CURRENT.filters[filterKey];
        });
    }

    function updateList() {
        var isCached, listRequestId;

        listRequestId = ++STATUS.listRequestId;

        if (!canLoadList()) {
            updateHasMore(false);

            if (STATUS.$list) {
                STATUS.$list.empty();
            }

            showWizard();

            return;
        }

        hideWizard();

        isCached = (STATUS.CURRENT.items.length > 0);

        if (STATUS.$list) {
            STATUS.$list.empty();
        }

        loadList(true).then(function() {
            return isCached ? syncList() : null;
        }).then(function() {
            if (listRequestId !== STATUS.listRequestId) {
                return false;
            }

            return renderList().then(function() {
                return true;
            });
        }).then(function(isCurrent) {
            if (!isCurrent) {
                return;
            }

            if (STATUS.CURRENT.hasMore) {
                startObserver();
            }

            setFocus();
        });
    }

    function refreshList() {
        if (!STATUS.active || !STATUS.$list || !canLoadList()) {
            return;
        }

        syncList().then(function() {
            return renderListItems(STATUS.CURRENT.items);
        }).then(function($items) {
            STATUS.$list.empty().append($items);
            updateHasMore(STATUS.CURRENT.hasMore);

            return addNowSeparator();
        });
    }

    function syncList() {
        var cacheItem;

        cacheItem = STATUS.CURRENT;

        return Api.request('/battle/league/matchday/listUpdate', {
            filters: cacheItem.filters,
            timestamp: cacheItem.timestamp || 0,
            ids: cacheItem.items.map(function(item) {
                return item.id;
            })
        }).then(function(result) {
            if (cacheItem !== STATUS.CURRENT) {
                return;
            }

            if (result.reset) {
                resetCacheItem(cacheItem);
                return loadList(true);
            }

            (result.removed || []).forEach(function(matchdayId) {
                removeCurrentItem(matchdayId);
            });

            (result.list || []).forEach(function(matchday) {
                removeCurrentItem(matchday.id);
                insertCurrentItem(matchday);
            });

            cacheItem.offset = cacheItem.items.length;
            cacheItem.timestamp = result.timestamp || cacheItem.timestamp;
            cacheItem.now = result.now || cacheItem.now;
        }).catch(function(error) {
            console.error(error);
        });
    }

    function removeCurrentItem(matchdayId) {
        var index;

        index = STATUS.CURRENT.items.findIndex(function(item) {
            return (item.id === matchdayId);
        });

        if (index >= 0) {
            STATUS.CURRENT.items.splice(index, 1);
        }
    }

    function insertCurrentItem(matchday) {
        var index;

        index = STATUS.CURRENT.items.findIndex(function(item) {
            return (compareItems(matchday, item) < 0);
        });

        if (index >= 0) {
            STATUS.CURRENT.items.splice(index, 0, matchday);
        } else if (!STATUS.CURRENT.hasMore) {
            STATUS.CURRENT.items.push(matchday);
        }
    }

    function compareItems(itemA, itemB) {
        var keyA, keyB;

        keyA = `${itemA.dateTimeMatchdayDate || ''} ${itemA.dateTimeMatchdayTime || ''}`;
        keyB = `${itemB.dateTimeMatchdayDate || ''} ${itemB.dateTimeMatchdayTime || ''}`;

        if (keyA !== keyB) {
            return (keyA < keyB) ? -1 : 1;
        }

        return String(itemA.id).toLowerCase().localeCompare(String(itemB.id).toLowerCase());
    }

    function loadList(isFirstLoad) {
        return new Promise(function(resolve, reject) {
            var timer;

            if (STATUS.isLoading) {
                timer = setInterval(function() {
                    if (STATUS.isLoading) {
                        return;
                    }

                    clearInterval(timer);
                    loadList(isFirstLoad).then(resolve).catch(reject);
                }, 100);

                return;
            }

            if (isFirstLoad && STATUS.CURRENT.items.length > 0) {
                updateHasMore(STATUS.CURRENT.hasMore);
                return resolve(STATUS.CURRENT.items);
            }

            STATUS.isLoading = true;

            ScoreTrekBattle.View.loadingBackground('League.Matchdays.loadList', true);

            Api.request('/battle/league/matchday/list', {
                filters: STATUS.CURRENT.filters,
                offset: STATUS.CURRENT.offset
            }).then(function(result) {
                if (result.list && result.list.length > 0) {
                    STATUS.CURRENT.offset += result.list.length;
                    STATUS.CURRENT.items = STATUS.CURRENT.items.concat(result.list);
                }

                if (result.timestamp) {
                    STATUS.CURRENT.timestamp = result.timestamp;
                }

                if (result.now) {
                    STATUS.CURRENT.now = result.now;
                }

                updateHasMore(!!result.hasMore);

                resolve(result.list || null);
            }).catch(reject).finally(function() {
                STATUS.isLoading = false;
                ScoreTrekBattle.View.loadingBackground('League.Matchdays.loadList', false);
            });
        });
    }

    function updateHasMore(hasMore) {
        STATUS.CURRENT.hasMore = hasMore;

        if (!STATUS.CURRENT.hasMore) {
            stopObserver();
        }

        if (STATUS.$loadMore) {
            STATUS.$loadMore.css('display', STATUS.CURRENT.hasMore ? '' : 'none');
        }
    }

    function loadMore() {
        return new Promise(function(resolve) {
            if (!STATUS.CURRENT.hasMore) {
                return resolve(false);
            }

            ScoreTrekBattle.View.loadingBackground('League.Matchdays.loadMore', true);

            loadList().then(function() {
                return renderList();
            }).then(function() {
                resolve(STATUS.CURRENT.hasMore);
            }).catch(function() {
                resolve(false);
            }).finally(function() {
                ScoreTrekBattle.View.loadingBackground('League.Matchdays.loadMore', false);
            });
        });
    }

    function renderList() {
        return new Promise(function(resolve) {
            var newItems;

            STATUS.isRendering = true;

            newItems = STATUS.CURRENT.items.filter(function(item) {
                return STATUS.$list[0].querySelector(`[data-matchday-id="${item.id}"]`) === null;
            });

            if (newItems.length === 0) {
                STATUS.isRendering = false;
                return resolve(false);
            }

            renderListItems(newItems, getRenderedSeparators()).then(function($items) {
                STATUS.$list.append($items);

                addNowSeparator().then(function() {
                    resolve(true);
                });
            }).finally(function() {
                STATUS.isRendering = false;
            });
        });
    }

    function getRenderedSeparators() {
        var separators;

        separators = {};

        STATUS.$list.children('[data-separator]').each(function() {
            separators[this.dataset.separator] = true;
        });

        return separators;
    }

    function renderListItems(items, renderedSeparators) {
        return new Promise(function(resolve) {
            var promises, currentYearMonthZero, addedSeparators;

            promises = [];
            currentYearMonthZero = 0;
            addedSeparators = $.extend({}, renderedSeparators || {});

            items.forEach(function(item) {
                var itemDate;

                itemDate = getMatchdayDate(item);

                if (!addedSeparators[itemDate.yearMonthZero] && (itemDate.yearMonthZero !== currentYearMonthZero)) {
                    currentYearMonthZero = itemDate.yearMonthZero;
                    addedSeparators[currentYearMonthZero] = true;
                    promises.push(renderMonth(currentYearMonthZero, itemDate.monthText, itemDate.yearText, itemDate.yearMonthText));
                }

                promises.push(renderItem(item, itemDate));
            });

            Promise.all(promises).then(function($items) {
                resolve($items);
            });
        });
    }

    function addNowSeparator() {
        return new Promise(function(resolve) {
            var beforeNowItem, afterNowItem;

            if (!STATUS.$list) {
                return resolve();
            }

            STATUS.$list.find('[data-separator="NOW"]').remove();

            if (STATUS.CURRENT.now) {
                STATUS.$list.find('[data-separator]').each(function() {
                    var time;

                    time = parseInt(this.dataset.separator, 10) || 0;

                    if (!time) {
                        return;
                    }

                    if (time < STATUS.CURRENT.now) {
                        beforeNowItem = this;
                    }

                    if (time >= STATUS.CURRENT.now) {
                        afterNowItem = this;
                    }

                    if (beforeNowItem && afterNowItem) {
                        return false;
                    }
                });
            }

            if (beforeNowItem && afterNowItem) {
                ScoreTrekBattle.Template.render('tournament/listItemNow').then(function(view) {
                    view.$view.attr('data-separator', 'NOW');
                    $(afterNowItem).before(view.$view);
                    resolve();
                });

                return;
            }

            resolve();
        });
    }

    function renderMonth(yearMonthDay, monthText, year, yearMonth) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/listItemMonth', {month: monthText, year: year}).then(function(view) {
                view.$view.attr({
                    'data-separator': yearMonthDay,
                    'data-month': yearMonth
                });
                resolve(view.$view);
            });
        });
    }

    function renderItem(item, itemDate) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('league/matchdayItem', {
                matchday: item,
                itemDate: itemDate
            }, true).then(function(itemView) {
                itemView.$view.attr({
                    'data-separator': itemDate.yearMonthDay,
                    'data-month': itemDate.yearMonthText
                });
                itemView.$view.find('[data-ref-id="plan"]').remove();
                resolve(itemView.$view);
            });
        });
    }

    function getMatchdayDate(item) {
        var dateString, timeString, year, month, day, hour, minute;

        dateString = item.dateTimeMatchdayDate || '0000-00-00';
        timeString = item.dateTimeMatchdayTime || '00:00';

        year = dateString.substring(0, 4);
        month = dateString.substring(5, 7);
        day = dateString.substring(8, 10);

        hour = timeString.substring(0, 2);
        minute = timeString.substring(3, 5);

        return {
            monthText: __i18n(`date/month/${month}`),
            monthShort: __i18n(`date/month/short/${month}`),
            yearText: `${year}`,
            yearMonthText: `${year}${month}`,
            yearMonthZero: parseInt(`${year}${month}00` + '0000', 10),
            yearMonthDay: parseInt(`${year}${month}${day}${hour}${minute}`, 10),
            dayText: `${day}`
        };
    }

    function setFocus() {
        if (!STATUS.$view) {
            return;
        }

        ListState.restoreScrollTop(STATUS.$view, STATUS.CURRENT.scrollTop);
    }

    // ── View lifecycle ───────────────────────────────────────

    // The router hands the path segments after /league/matchdays in as
    // arguments — that is the shared link's selection.
    function collectPathArgs(args) {
        return Array.prototype.slice.call(args).filter(function(segment) {
            return String(segment || '').trim() !== '';
        });
    }

    function applyPath(pathArgs) {
        storeScrollTop(AnimationHandler.getScrollTop());

        STATUS.filterRequestId = (STATUS.filterRequestId || 0) + 1;

        CONFIG.FILTER_ORDER.forEach(function(filterKey, index) {
            resetFilter(filterKey);

            if (index > 0) {
                disableFilter(filterKey);
            }
        });

        STATUS.CURRENT = getCacheItem(`${CONFIG.VIEW_ID}/${pathArgs.join('/')}`) || createCacheItem({});

        if (restoreCachedList()) {
            return;
        }

        restoreFiltersFromPath(pathArgs);
    }

    function onViewRender() {
        var pathArgs;

        pathArgs = collectPathArgs(arguments);

        return new Promise(function(resolve) {
            var requestedPath;

            requestedPath = (pathArgs.length > 0) ? `${CONFIG.VIEW_ID}/${pathArgs.join('/')}` : CACHE.lastPath;
            STATUS.CURRENT = getCacheItem(requestedPath) || createCacheItem((pathArgs.length > 0) ? {} : CACHE.lastFilters);
            STATUS.pathArgs = pathArgs;

            ScoreTrekBattle.View.updateMenu('/league/matchdays');

            ScoreTrekBattle.Template.render('league/matchdays').then(function(view) {
                STATUS.active = true;
                STATUS.view = view;
                STATUS.$view = view.$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');
                STATUS.$loadMore = STATUS.$view.find('[data-id="loadMore"]');

                STATUS.$list.on('click', '[data-id="groupLink"]', function(event) {
                    if (this.pathname === location.pathname) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                });

                STATUS.$view.attr('data-has-filters', 'no');
                STATUS.$view.find('[data-id="filterCount"]').text('0');
                STATUS.$view.find('[data-id="filtersContent"]').hide();

                // Hide both wizard and list until updateList decides
                STATUS.$view.find('[data-id="wizard"]').css('display', 'none');
                STATUS.$view.find('[data-id="listWrapper"]').css('display', 'none');
                STATUS.$view.find('[data-id="filters"]').css('display', 'none');

                STATUS.wizardFilters = {};

                updateHasMore(false);

                initFilters();

                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;

            STATUS.observer = LazyLoadObserver(STATUS.$loadMore[0], loadMore, {margin: window.innerHeight});

            resolve();
        });
    }

    function onViewUpdate() {
        var pathArgs;

        pathArgs = collectPathArgs(arguments);

        return new Promise(function(resolve) {
            if (pathArgs.length === 0) {
                return resolve();
            }

            if (!STATUS.isFiltersLoaded) {
                STATUS.pathArgs = pathArgs;

                return resolve();
            }

            applyPath(pathArgs);

            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            storeScrollTop(AnimationHandler.getScrollTop());
            stopObserver();
            resetStatus();
            resolve();
        });
    }

    function startObserver() {
        if (STATUS.observer) {
            STATUS.observer.start();
        }
    }

    function stopObserver() {
        if (STATUS.observer) {
            STATUS.observer.stop();
        }
    }

    _this = {
        renderList: function(items) {
            return renderListItems(items);
        },

        getCurrentName: function() {
            return STATUS.$view ? getShareName() : __i18n('share/name/matchdays');
        },

        getShareHash: function() {
            return STATUS.$view ? buildPath() : CONFIG.VIEW_ID;
        }
    };

    ScoreTrekBattle.View.register('/league/matchdays', onViewRender, onViewLoad, onViewUpdate, onViewUnload);

    ScoreTrekBattle.Event.on('action.matchdays.filters.reset', function() {
        if (!STATUS.$view) {
            return;
        }

        resetFilters();
        toggleFilters(false);
    });

    ScoreTrekBattle.Event.on('action.matchdays.filters.toggle', function() {
        if (!STATUS.$view) {
            return;
        }

        toggleFilters(!STATUS.$view.find('[data-id="filters"]').hasClass('isOpen'));
    });

    ScoreTrekBattle.Event.on('window.scrolled', function(event, scrollTop, isDown) {
        if (!STATUS.active) {
            return;
        }

        if (window.JQUERY_IS_ANIMATING) {
            return;
        }

        if (isDown && STATUS.$view && !isFiltersToggleLocked() && isFiltersObstructive()) {
            toggleFilters(false);
        }
    });

    ScoreTrekBattle.Event.on('matchday.created matchday.updated', function() {
        refreshList();
    });

    ScoreTrekBattle.Event.on('favorite.changed', function(favoriteType, refId, isFavorite) {
        if (favoriteType !== 'matchday') {
            return;
        }

        Object.keys(CACHE.items).forEach(function(path) {
            CACHE.items[path].items.forEach(function(item) {
                if (item.id === refId) {
                    item.isFavorite = isFavorite;
                }
            });
        });
    });

    return _this;
})();
